// extracted by mini-css-extract-plugin
module.exports = {"divContent":"ProductImportTotalStyles_divContent__1Xicd","labelTitle":"ProductImportTotalStyles_labelTitle__2eY1g"};